export const ELOQUENT_MODELS = {
    CoreItem: "Tynda\\Core\\Models\\Item",
    CoreEstablishment: "Tynda\\Core\\Models\\Establishment",
    CoreSetting: "Tynda\\Core\\Models\\Setting",
}